import ResourceStrings from "../resourceStrings";
import { PQ4castDataType } from "../models/metMap/pQ4castDataType";
export default class ForecastTypeLogic {
    static all() {
        return [PQ4castDataType.Voltage, PQ4castDataType.Ptot, PQ4castDataType.Qtot, PQ4castDataType.ThdU, PQ4castDataType.UnbU];
    }
    static getName(dataType, abbreviated = false) {
        switch (dataType) {
            case PQ4castDataType.Voltage:
                return abbreviated ? "U" : ResourceStrings.VOLTAGE;
            case PQ4castDataType.Ptot:
                return abbreviated ? "P" : ResourceStrings.PTOT;
            case PQ4castDataType.Qtot:
                return abbreviated ? "Q" : ResourceStrings.QTOT;
            case PQ4castDataType.ThdU:
                return abbreviated ? "THD" : ResourceStrings.THD;
            case PQ4castDataType.UnbU:
                return abbreviated ? "Unb" : ResourceStrings.UNBALANCE;
        }
        return "?";
    }
    static getUnit(dataType) {
        switch (dataType) {
            case PQ4castDataType.Voltage: return "V";
            case PQ4castDataType.Ptot: return "W";
            case PQ4castDataType.Qtot: return "VAr";
            case PQ4castDataType.ThdU: return "%";
            case PQ4castDataType.UnbU: return "%";
            case PQ4castDataType.Temperature: return "°C";
            case PQ4castDataType.Frequency: return "Hz";
        }
        return "?";
    }
    static isScalable(dataType) {
        return !(dataType === PQ4castDataType.UnbU || dataType === PQ4castDataType.ThdU);
    }
}
